import { IProductVariation } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const productVariationApi = crudEndpointsFactory<IProductVariation>()('product-variations', 'ProductVariations');
